$(document).ready(function(){
    var autoplay = ($('[data-slick-slider]').attr('data-slick-slider-autoplay') == 'true')
    //console.log(autoplay)
    var timer = $('[data-slick-slider]').attr('data-slick-slider-autoplay-timer');
    //console.log(timer)
    $('[data-slick-slider]').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoplay,
        autoplaySpeed: timer,
    });
});